import React from "react";
import Beneficios from "../../atoms/BeneficiosList";
import styled from "styled-components";
import AutoForm from "../landing-page/ModalForms/AutoForm";
import { ProductDetailFormTitle } from "../../../constants/index/productDetails";
import { AllProductsForms } from "../../../hooks";

const FormTitle = (data) => (
	<>
		{data?.title}
		{data?.subTitle}
	</>
);

const Details = ({ title, type, img, message }) => {
	return (
		<Wrapper className='user-account benefit-section product-detail'>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12'>
						<h1 className='text-center pb-2'>
							{title} {img && <img style={{ width: 180 }} src={img} alt='' />}
						</h1>
					</div>
					<div className='col-md-12 col-lg-5'>
						<Beneficios />
					</div>
					<div className='col-md-12 col-lg-7 pl-lg-5'>
						<AllProductsForms
							message={message}
							type={type}
							title={FormTitle(
								ProductDetailFormTitle.filter(
									(formTitle) => formTitle.id === type,
								)[0],
							)}
						/>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default Details;

const Tabs = styled.p`
	font-size: 29px;
	color: white;
	width: 20px;
	cursor: pointer;
	&:first-child {
		margin-right: 12px;
	}
`;

export const Wrapper = styled.section`
	.mr-4,
	.mx-4 {
		margin-right: 2.8rem !important;
	}
	.ml-masc {
		margin-left: 2.2rem;
	}
	.active {
		width: 20px;
		color: #3cdbc0 !important;
		border-bottom: 4px solid white;
	}
`;

export const Wrapperx = styled.section`
	width: 602px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	position: relative;
	padding: 10px;
	border-radius: 20px;
	width: 800px;
	height: auto;
	top: -20px;
	left: -140px;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	z-index: 9999;
	height: auto;
	@media (max-width: 1191px) {
		left: -200px;
	}
	@media (max-width: 992px) {
		left: -120px;
	}
	@media (max-width: 768px) {
		left: -25px;
		width: 427px;
		margin-top: 0%;
	}

	.items-center {
		align-items: left;
		justify-content: center;
	}
	.flex {
		display: flex;
		align-content: center;

		@media (max-width: 768px) {
			flex-direction: column;
		}
	}

	.active {
		width: 20px;
		color: #3cdbc0 !important;
		border-bottom: 4px solid white;
	}

	.input-icon {
		align-items: center;
		position: relative;

		input {
			width: 100%;
		}

		svg {
			position: absolute;
			color: grey;
			right: 0;
			margin-right: 10px;
			@media (max-width: 768px) {
				top: 8px;
			}
		}
	}

	.form-group {
		display: block;
		margin-bottom: 15px;

		@media (max-width: 768px) {
			margin-bottom: 5px;
		}
	}

	.form-group input {
		padding: 0;
		height: initial;
		width: initial;
		margin-bottom: 0;
		display: none;
		cursor: pointer;
	}

	.form-group label {
		position: relative;
		cursor: pointer;
		color: white;
	}

	.form-group label:before {
		content: "";
		-webkit-appearance: none;
		background-color: transparent;
		border: 2px solid white;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
			inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
		padding: 10px;
		display: inline-block;
		position: relative;
		vertical-align: middle;
		cursor: pointer;
		margin-right: 5px;
	}

	.form-group input:checked + label:after {
		content: "";
		display: block;
		position: absolute;
		top: 2px;
		left: 9px;
		width: 6px;
		height: 14px;
		border: solid #0079bf;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	[type="radio"]:checked,
	[type="radio"]:not(:checked) {
		position: absolute;
		left: -9999px;
	}
	[type="radio"]:checked + label,
	[type="radio"]:not(:checked) + label {
		position: relative;
		padding-left: 28px;
		cursor: pointer;
		line-height: 20px;
		display: inline-block;
		color: #666;
	}
	[type="radio"]:checked + label:before,
	[type="radio"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		width: 18px;
		height: 18px;
		border: 1px solid #ddd;
		border-radius: 100%;
		background: #fff;
	}
	[type="radio"]:checked + label:after,
	[type="radio"]:not(:checked) + label:after {
		content: "";
		width: 18px;
		height: 18px;
		border: 2px solid white;
		background: #3cdbc0;
		position: absolute;

		border-radius: 100%;
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
	[type="radio"]:not(:checked) + label:after {
		opacity: 0;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	[type="radio"]:checked + label:after {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
		left: 0;
	}

	.disabled {
		select {
			opacity: 0.8 !important;
		}
	}
`;

export const Button = styled.button`
	background: #f89900;
	border: 1px solid white;
	color: white;
	text-align: center;

	padding: 11px;
	border-radius: 50px;
	width: 140px;
	margin-top: 2%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 2%;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const InputContainer = styled.div`
	width: 80%;
	display: flex;
	margin-right: 10px;
	align-content: center;
	flex-direction: column;

	@media (max-width: 768px) {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		margin-top: 10px;
	}

	label {
		margin-left: 10px;
		color: white;
		font-size: 15px;
		@media (max-width: 768px) {
			margin-left: 0px;
		}
	}

	textarea {
		border: none;

		border-radius: 5px;
		height: 30px;
		opacity: 0.6980392156862745;
		background: white;
	}

	input {
		border: none;
		padding: 15px;
		border-radius: 5px;
		height: 17px;
		opacity: 1;
		background: white;
	}

	.custom-select-container {
		position: relative;
		@media (max-width: 1191px) {
			width: 140px;
		}
		@media (max-width: 768px) {
			width: 324px;
		}
		width: 160px;
	}

	select {
		width: 160px;
		@media (max-width: 1191px) {
			width: 140px;
		}
		@media (max-width: 768px) {
			width: 324px;
		}

		padding: 2px;
		border: none;
		border-radius: 5px;
		background-color: #c3c5cd;
		color: white;
		outline: none;
		appearance: none;
	}

	span {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		position: absolute;
		width: 30px;
		height: 100%;
		right: 0;
		top: 0;
		pointer-events: none;
	}

	span::after {
		position: absolute;
		content: "";
		border-style: solid;
		border-width: 7px;
		border-color: #808080 transparent transparent transparent;
		top: 47%;
		left: 28%;
	}
`;
